export default __webpack_public_path__ + "static/media/Heather 9781843620228.126b1d50.jpg";